/* ============================================================
   TheNadShop · Scroll reveal
   ----------------------------------------
   Adds .tns-reveal / .tns-reveal-stagger classes to selected
   elements, then uses IntersectionObserver to add .is-visible
   when they enter the viewport.

   Hero is intentionally NOT animated (it's above the fold).
   ============================================================ */
(function(){
  // Bail early if API not available — content stays visible (no class added).
  if (!('IntersectionObserver' in window)) return;

  // Skip animations for users who prefer reduced motion.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Add tns-reveal to the top-level wrappers of each home section (except hero).
  const revealSelectors = [
    '.tns-trust',
    '.tns-buy',
    '.tns-assist-section .tns-assist',
    '.tns-benefits',
    '.tns-faqs',
    '.tns-footer'
  ];
  revealSelectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.classList.add('tns-reveal'));
  });

  // Stagger product cards inside the buy grid.
  document.querySelectorAll('.tns-buy__products').forEach(el => {
    el.classList.add('tns-reveal-stagger');
  });
  // Stagger trust items.
  document.querySelectorAll('.tns-trust__grid').forEach(el => {
    el.classList.add('tns-reveal-stagger');
  });

  // Single observer that unobserves after first reveal (one-shot).
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting){
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -8% 0px'
  });

  document
    .querySelectorAll('.tns-reveal, .tns-reveal-stagger')
    .forEach(el => io.observe(el));
})();
